import * as React from 'react';
import { displayTime, randomInt } from '../functions';
import { AimTrainingBox, AimBoard, MyAimOutlined, ScoreBoard, CurrentScore } from './AimTraining.css';
import { Button } from 'antd';
import { max, Config } from './config';
import UserContext from '../../contexts/UserContext';
import ShowTime from '../../components/components/ShowTime/ShowTime';
import { GameOverAnimation } from '../VisualMemory/VisualMemory.css';
import { GameOverButton, GameOverInfoBox, GameOverRow } from '../SequenceMemory/SequenceMemory.css';
import gamesList from '../../components/components/ChooseGame/gamesList';
import { saveUserRecord } from '../api';

const AimTraining = () => {
    const { useState, useContext } = React;
    const {user} = useContext(UserContext);
    const [started, setStarted] = useState(false);
    const [coor, setCoor] = useState({x: 0, y: 0});
    const [show, setShow] = useState(false);
    const [hide, setHide] = useState(true);
    const [score, setScore] = useState(0);
    const [gameTime, setGameTime] = useState(Config.gameTime);
    const [gameOver, setGameOver] = useState(false);
    const [scoreSaved, setScoreSaved] = useState(false);
    const startTime = React.useRef(0);
    const interval = React.useRef<NodeJS.Timeout | null>(null);

    const handleStart = () => {
        setHide(true);
        setShow(false);
        setGameOver(false);
        setScoreSaved(false);
        setScore(0);
        const randX = randomInt(0, max.x);
        const randY = randomInt(0, max.x);
        setCoor({x: randX, y: randY});
        setStarted(true);
        setHide(false);
        startTime.current = Date.now();
        setTimeout(() => {
            setShow(true);
        }, 200);
        interval.current = setInterval(() => {
            setGameTime(gt => {
                console.log((Date.now() - startTime.current))
                if (Config.gameTime - (Date.now() - startTime.current) <= 0) {
                    if (interval.current) {
                        clearInterval(interval.current);
                        setHide(true);
                        setShow(false);
                        setGameOver(true);
                    }
                    return 0;
                } else {
                    return Config.gameTime - (Date.now() - startTime.current);
                }
            });
        }, 50);
    };

    const handleClickAim = () => {
        setShow(false);
        setHide(true);
        setScore(scr => scr + 1);
        setTimeout(() => {
            setHide(false);
            const randX = randomInt(0, max.x);
            const randY = randomInt(0, max.x);
            setCoor({x: randX, y: randY});
            setShow(true);
        }, 50);
    };

    const saveScore = async () => {
        const gameId = gamesList.find(x => x.id === 'at')?.gameId || 0;
        const saved = await saveUserRecord(user.id, score, 0, gameId);
        setScoreSaved(true);
        console.log(saved);
    };

    return (
        <AimTrainingBox>
            {started && <ScoreBoard><CurrentScore>SCORE {score}</CurrentScore><ShowTime time={displayTime(gameTime)} /></ScoreBoard>}
            {gameOver && <GameOverAnimation>
                <GameOverInfoBox>
                    <GameOverRow>
                        SCORE {score}
                    </GameOverRow>
                    <GameOverButton>
                        <Button onClick={handleStart}>PLAY AGAIN</Button>
                        <Button disabled={scoreSaved} style={{marginLeft: 5}} onClick={saveScore}>{scoreSaved ? 'SAVED' : 'SAVE SCORE'}</Button>
                    </GameOverButton>
                </GameOverInfoBox>
            </GameOverAnimation>}
            <AimBoard>
                {!started && <Button onClick={handleStart}>Start</Button>}
                <MyAimOutlined onClick={handleClickAim} show={show} hide={hide} style={{position: 'absolute', top: coor.x, left: coor.y}} />
            </AimBoard>
        </AimTrainingBox>
    );
};

export default AimTraining;